import React, {useState} from 'react'
import AppLink from '../../../../components/AppLink';
import BrowserLink from '../../../../components/BrowserLink';
import CountDownTimer from "../CountDownTimer";
import CloseSvg from "../Svg/CloseSvg";
import * as cl from './PromoBanner.module.scss'

const PromoBanner = ({banner}) => {
  const [isShow, setIsShow] = useState(true)

  if (!isShow || !banner) return null;

  const close = () => {
    setIsShow(false)
  }

  const bgColor = banner.color ? banner.color : 'linear-gradient(267.09deg, #8348FF 0%, #4273F1 100%)';
  const fontColor = banner.fontColor ? banner.fontColor : '#fff';
  const content = banner.layout === 'image' ? (
    <>
      <img src={banner.image} alt="" className={cl.image} />
      <img src={banner.image_mobile} alt="" className={`${cl.image} ${cl.image_mobile}`} />
    </>
  ) : (
    <>
      <div className={cl.info}>
        <h2 className={cl.info__title} style={{color: fontColor}}>{banner.title}</h2>
        <p className={cl.info__content} dangerouslySetInnerHTML={{__html: banner.content}} />
        {banner.button.label && (
          banner.button.react_route ? (
            <AppLink to={banner.button.react_route} className={cl.info__button}>{banner.button.label}</AppLink>
          ) : (
            <BrowserLink href={banner.button.url} className={cl.info__button}>{banner.button.label}</BrowserLink>
          )
        )}
      </div>

      {banner.timer && (
        <div className={cl.timer}>
          {banner.timer.type === 'basic' ? (
            <CountDownTimer date={banner.timer.data} styles={{
              background: bgColor,
              color: fontColor,
            }}
            />
          ) : (
            <div dangerouslySetInnerHTML={{__html: banner.timer.data}} />
          )}
        </div>
      )}

      {banner.image && (
        <BrowserLink href={banner.image_url} className={cl.link}>
          <img src={banner.image} alt='product' className={cl.link__img} />
        </BrowserLink>
      )}
    </>
  );

  return (
    <article
      className={`${cl.wrapper} ${banner.layout === 'content' ? cl.wrapper_content : ''}`}
      style={{
        background: bgColor,
        color: fontColor,
      }}
    >
      <button className={cl.close} onClick={() => close()}>
        <CloseSvg/>
      </button>

      {banner.layout === 'image' ? (
        banner.react_route ? (
          <AppLink to={banner.react_route}>{content}</AppLink>
        ) : (
          <BrowserLink href={banner.image_url}>{content}</BrowserLink>
        )
      ) : content}
    </article>
  )
}

export default PromoBanner
